document.addEventListener("DOMContentLoaded", function () {

  // Category Switching
  const categoryLinks = document.querySelectorAll(".faq-category-link");
  const categoryItems = document.querySelectorAll(".faq-category-item");
  // Changed: Target accordion-databox instead of faq-group
  const groups = document.querySelectorAll(".accordion-databox");

  categoryLinks.forEach(link => {
    link.addEventListener("click", function(e){
      e.preventDefault();

      const category = this.dataset.scategory;

      categoryItems.forEach(item => item.classList.remove("is-active"));
      this.closest(".faq-category-item").classList.add("is-active");

      groups.forEach(group => group.classList.remove("is-active"));

      // Changed: Target accordion-databox instead of faq-group
      const activeGroup = document.querySelector(
        '.accordion-databox[data-category="' + category + '"]'
      );

      if (activeGroup) {
        activeGroup.classList.add("is-active");
      }
    });
  });

  // Accordion
  document.addEventListener("click", function(e){

    const trigger = e.target.closest(".accordion-trigger");

    if(!trigger) return;

    e.preventDefault();

    const row = trigger.closest(".accordion-row");

    row.classList.toggle("active");

  });

});